import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd/lib';
import { graphql, compose } from 'react-apollo';

import MenuPropio from './Menu';
import Loading from './LegacyLoading';
import getUsuario from '../../graphql/querys/auth/getUsuario.graphql';
import getEnvironment from '../../graphql/querys/common/getEnvironment.graphql';

@compose(
  graphql(getUsuario),
  graphql(getEnvironment, {
    name: 'getEnvironment',
  })
)
class NavBar extends React.Component {
  state = {
    collapsed: false,
  };

  render() {
    const { data, authenticator } = this.props;

    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario) {
      if (window.location.pathname === '/login') {
        return null;
      } else {
        window.location.replace('/login');
      }
    }

    const { Header } = Layout;
    const background =
      this.props.getEnvironment.getEnvironment === 'staging' ||
      this.props.getEnvironment.getEnvironment === 'develop'
        ? '#804000'
        : 'inherith';

    return (
      <Header
        style={{
          position: 'fixed',
          zIndex: 2,
          top: 0,
          width: '100%',
          backgroundColor: background,
        }}
        id="navbar-header"
      >
        <MenuPropio
          environment={this.props.getEnvironment.getEnvironment}
          authenticator={authenticator}
        />
      </Header>
    );
  }
}

NavBar.propTypes = {
  data: PropTypes.object,
};

export default NavBar;
// export default NavBar;
